<template>
  <div class="click__infos u-bg-black u-white u-pad-sm" v-if="$route.query.editor">
    <div>
      Position
    </div>
    <div>
      x: {{position.x}}
      <button @click="onCopy(position.x)">
        Copy to clipboard
      </button>
    </div>
    <div>
      y: {{position.y}}
      <button @click="onCopy(position.y)">
        Copy to clipboard
      </button>
    </div>
    <div>
      z: {{position.z}}
      <button @click="onCopy(position.z)">
        Copy to clipboard
      </button>
    </div>
  </div>
</template>

<script>
import { webGL } from '@/webGL/WebGL'

import Exporter from '@/utils/Exporter'
import CopyPaste from '@/utils/CopyPaste'

export default {
  data () {
    return {
      position: {x: 0, y: 0, z: 0}
    }
  },

  mounted () {
    window.addEventListener('click', event => {
      webGL.scene.updateMatrix()
      const pos = this.$device.getIntersectPosition(webGL.scene.children)
      if (pos) {
        this.position = pos
      }
    })
  },

  methods: {
    onCopy (arg) {
      CopyPaste.makeCopy({ values: arg })
    }
  }
}
</script>

<style lang="stylus">
.click__infos 
  position absolute
  top 7px
  left 7px
  width 300px
</style>